import clsx from "clsx";
import { CheckIcon } from "../../../icons";
import CalendarColorBadge from "../../atom/Calendar/CalendarColorBadge";

import {
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "../../atom/Dropdown/Dropdown";
import { UserCalendarType } from "../../../types/userCalendars/type";

interface MyCalendarDropdownProps {
  selectedValue?: string;
  calendarList: UserCalendarType[];
  onSelect: (stringifiedId: string) => void;
}

const MyCalendarDropdownContent = ({
  selectedValue,
  calendarList,
  onSelect,
}: MyCalendarDropdownProps) => {
  if (!calendarList.length) return null;

  return (
    <DropdownMenuContent
      width="200px"
      sideOffset={5}
      align={"end"}
      side={"bottom"}
      onClick={(e) => e.stopPropagation()}
    >
      <DropdownMenuRadioGroup
        value={selectedValue}
        onValueChange={onSelect}
      >
        {calendarList.map((calendar) => (
          <DropdownMenuRadioItem
            key={calendar.id}
            value={calendar.id.toString()}
            className="text-[12px] leading-[1] text-white flex items-center h-8 px-2 relative select-none  outline-none gap-[6px] data-[highlighted]:bg-w-8-hover group-data-[highlighted]:text-white group-data-[state=checked]:text-moba hover:bg-w-8-hover cursor-pointer"
          >
            <CalendarColorBadge color={calendar.backgroundColor} />
            <div
              className={clsx(
                "flex-grow whitespace-nowrap overflow-hidden text-ellipsis",
                selectedValue === calendar.id.toString() ? "text-moba" : "text-80"
              )}
            >
              {calendar.name}
            </div>
            {selectedValue === calendar.id.toString() && <CheckIcon color={"var(--moba)"} />}
          </DropdownMenuRadioItem>
        ))}
      </DropdownMenuRadioGroup>
    </DropdownMenuContent>
  );
};

export default MyCalendarDropdownContent;
